export { PagoRealizado } from "./views/view";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/pago/index.tsx